import { Inject, Injectable, OnDestroy } from '@angular/core';
import { filter, map, Observable, of, Subscription, take, tap } from 'rxjs';
import { AuditableModel } from '../../Misc/models/auditable.model';
import { DiscoverListTypeEnum } from '../../../api/mentions/enum/discover-list-type.enum';
import { DiscoverListsFilterModel } from '../models/discover-lists-filter.model';
import { DiscoverListFilterModel } from '../../../api/mentions/model/discover-list-filter.model';
import { SavedFilterDisplayModel } from '../components/SavedFilterWrapper/saved-filter-type.model';
import { IncludeExcludeEnum } from '../enums/include-exclude.enum';
import { monitoringFiltersEnum } from '../../../Monitor/Shared/enums/monitoring-filters.enum';
import { FilterListProviderServiceInterface } from './filter-list-provider-service.interface';

@Injectable()
export class DiscoverListsFilterService implements OnDestroy {

    private subscriptions: Subscription[] = [];
    constructor(
        @Inject('TargetingListService') public targetingListService: FilterListProviderServiceInterface,
        @Inject('TargetingSearchesService') public targetingSearchesService: FilterListProviderServiceInterface,
        @Inject('DistributionService') public distributionService: FilterListProviderServiceInterface
    ) {}

    getDiscoverList(discoverListType: DiscoverListTypeEnum): Observable<AuditableModel[]> {
        let source$: Observable<AuditableModel[]>;
        switch (discoverListType) {
            case DiscoverListTypeEnum.targetingList:
                source$ = this.targetingListService.getFilterListItems();
                break;
            case DiscoverListTypeEnum.targetingSearch:
                source$ = this.targetingSearchesService.getFilterListItems();
                break;
            case DiscoverListTypeEnum.distribution:
                source$ = this.distributionService.getFilterListItems();
                break;
            default:
                source$ = of([]);
        }
        return source$.pipe(take(1));
    }

    populateFilter(discoverListsFilter: DiscoverListsFilterModel, value: DiscoverListFilterModel, onlyCurrentValue: boolean = false) {
        const discoverListType = value.discoverListType;
        return this.getDiscoverList(discoverListType).pipe(
            tap(
                source => {
                    if(source) {
                        discoverListsFilter.source = source;
                        if(onlyCurrentValue) {
                            discoverListsFilter.setCurrentValue(value);
                        } else {
                            discoverListsFilter.setValue(value);
                        }
                    }
                }
            )
        );
    }

    constructFilterCard(value: DiscoverListFilterModel): Observable<SavedFilterDisplayModel> {
        let includeExclude: IncludeExcludeEnum;
        let listId: number;
        if(value.discoverList.exclude.length > 0) {
            includeExclude = IncludeExcludeEnum.exclude;
            listId = value.discoverList.exclude[0];
        } else {
            includeExclude = IncludeExcludeEnum.include;
            listId = value.discoverList.include[0];
        }

        return this.getDiscoverList(value.discoverListType).pipe(
            map(source => {
                const list = source.find(itm => itm.id === listId);

                if(!list) {
                    return null;
                }

                return {
                    filterName: 'Monitoring.filtersLocalization.discoverLists',
                    type: monitoringFiltersEnum.discoverLists,
                    includeExclude,
                    chips: [{
                        label: `Discover.listSource.chipLabel.${value.discoverListType}`,
                        labelArgs: {list: list?.name},
                        suffix: includeExclude ===  IncludeExcludeEnum.exclude ? 'Common.forms.chips.exclude.suffix' : ''
                    }]
                };
            }),
            filter(x => !!x)
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
